// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__17Odp","sendOtp":"AuthorizeToLogin_sendOtp__3ZRcC"};